export default "__VITE_ASSET__BAgZC6ym__"